import React from "react";
import { styled } from "@mui/material/styles";
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import colors from "assets/theme-dark/base/colors";
import { Theme } from "@mui/material/styles";
import { GroupCount } from "../../hooks/useSegmentationGroupedCount";
import { EllipsisWithTooltip } from "../EllipsisWithTooltip";
import { cruxyColors } from "../../theme/color-palette";

interface MiniGroupCountsCardProps {
  groupCounts: GroupCount[];
}

const MiniGroupCountsCard: React.FC<MiniGroupCountsCardProps> = ({ groupCounts }) => {
  if (groupCounts.length === 0) return null;

  return (
    <MDBox mt={1}>
      <MDTypography variant="caption" fontWeight="bold" mb={0.5}>
        Count Preview:
      </MDTypography>
      <CardContainer>
        {groupCounts.map((group, index) => (
          <CardItem key={index}>
            <TextContainer>
              <EllipsisWithTooltip placement="top">
                {group.groupValue === "null" ? "Empty rows" : group.groupValue}
              </EllipsisWithTooltip>
            </TextContainer>
            <MDTypography variant="caption" display="block">
              Count: {group.count}
            </MDTypography>
          </CardItem>
        ))}
      </CardContainer>
    </MDBox>
  );
};

const CardContainer = styled(MDBox)(({ theme }: { theme: Theme }) => ({
  display: "flex",
  overflowX: "auto",
  gap: theme.spacing(0.6),
  padding: theme.spacing(0.1),
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.background.default,
  scrollbarWidth: "thin",
  "&::-webkit-scrollbar": {
    height: "8px",
  },
  "&::-webkit-scrollbar-track": {
    background: colors.grey[800],
  },
  "&::-webkit-scrollbar-thumb": {
    background: colors.grey[600],
    borderRadius: "4px",
  },
}));

const CardItem = styled(MDBox)(({ theme }: { theme: Theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1.5),
  backgroundColor: cruxyColors.green.main,
  textAlign: "center",
  boxShadow: theme.shadows[1],
  maxWidth: "150px",
  minWidth: "90px",
  flexShrink: 0,
  overflow: "hidden",
  marginBottom: theme.spacing(0.7),
}));

const TextContainer = styled(MDTypography)(({ theme }: { theme: Theme }) => ({
  fontWeight: "bold",
  display: "block",
  maxWidth: "100%",
  overflow: "hidden",
  fontSize: "0.8rem",
}));

export default MiniGroupCountsCard;
